import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useSEO from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({
    title: "Page Not Found | ElectroMax Systems",
    description: "The page you're looking for doesn't exist. Head back home to browse our services.",
    robots: "noindex,follow",
  });
  useEffect(() => {
    // Signal 404 to prerenderers / crawlers that respect meta status if present.
    const meta = document.createElement("meta");
    meta.setAttribute("name", "prerender-status-code");
    meta.setAttribute("content", "404");
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
  return (
    <section className="min-h-[80vh] flex items-center justify-center pt-32 pb-24 grain relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[500px] h-[500px] bg-[#E60000]/10 blur-[140px] rounded-full" />
      </div>
      <div className="relative text-center px-6">
        <div className="font-display text-[22vw] leading-none tracking-tighter font-black text-white/[0.05] select-none">
          404
        </div>
        <div className="-mt-8 md:-mt-16">
          <div className="text-xs tracking-[0.24em] uppercase text-[#E60000] font-bold mb-4">Circuit not found</div>
          <h1 className="font-display text-4xl md:text-6xl font-black tracking-tighter">
            That page is off the grid.
          </h1>
          <p className="mt-4 text-white/70 max-w-md mx-auto">
            The URL you tried doesn&rsquo;t match any route. Head back to the mainline.
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 bg-[#E60000] hover:bg-[#FF1A1A] text-white font-bold px-6 py-4"
          >
            Back to home <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
